import AbstractCommand from "../../../../../../../shared/src/ranj/app/core/AbstractCommand";
import GameEvent from "../../../../../../../shared/src/ranj/app/core/GameEvent";
import SkinKeys from "../../../../../../../shared/src/ranj/app/ui/SkinKeys";
import GameModel from "../../../core/model/GameModel";
import Scenario from "../Scenario";

export default class FinishScenarioCommand extends AbstractCommand {
    /**
     * 
     * @param {soma.EventDispatcher} dispatcher
     * @param {GameModel} gameModel 
     */
    constructor(dispatcher, gameModel) {
        super(dispatcher);

        this._gameModel = gameModel;
    }

    execute(evt) {
        /** @type {Scenario} */
        const scenario = evt.params.scenario;
        this._gameModel.completeScenario(scenario.id);

        if (this._gameModel.completed) {
            this.dispatch(GameEvent.COMPLETED);
        } else {
            this.gotoScreen(SkinKeys.EPISODE_SELECTION_SCREEN);
        }
    }
}